import React from 'react';
import Frame from "../../common/Frame";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import {appdata, load} from "../../../logic_tmp/appdata/AppData";
import {CheckoutForm} from "./CheckoutForm";
import './Stripe.css';

const stripePromise = loadStripe('pk_live_Ym4pj7nfoaBPMuFYyUI0nViM006gcwB8eD');


export default function Stripe() {
    load();
    const options = {
        clientSecret: appdata.redirectData
    };
    return (
        <div>
            <Frame>
                <div id="smart-button-container">
                    <div className="stripe">
                        <Elements stripe={stripePromise} options={options} >
                            <CheckoutForm/>
                        </Elements>
                    </div>
                </div>
            </Frame>
        </div>
    );
}
